import { render, staticRenderFns } from "./PageMainEventCertificate.vue?vue&type=template&id=08a51bfd&scoped=true&"
import script from "./PageMainEventCertificate.vue?vue&type=script&lang=js&"
export * from "./PageMainEventCertificate.vue?vue&type=script&lang=js&"
import style0 from "./PageMainEventCertificate.vue?vue&type=style&index=0&id=08a51bfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a51bfd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VContainer,VIcon,VImg,VLazy,VSimpleTable})
